import { gql } from "@apollo/client";
export const GET_ROLE_BY_ORG = gql`
  query getRoles($orgId: Int!) {
    roleByOrg(orgId: $orgId) {
      roleId
      name
      orgId
    }
  }
`;

export const GET_ROLES = gql`
  query Roles {
    roles {
      roleId
      name
    }
  }
`;










export const GET_ORG_ROLES = gql`
  query GetRoleByOrgId($orgId: Int!) {
    getRoleByOrgId(orgId: $orgId) {
      name
      roleId
      deptId
      headOfOrg
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($roleId: Int!, $deptId: Int!, $orgId: Int!) {
    deleteRole(roleId: $roleId, deptId: $deptId, orgId: $orgId)
  }
`;

export const CREATE_HEAD_OF_ORG = gql`
  mutation CreateHeadOfOrg($input: headOfOrgInput) {
    createHeadOfOrg(input: $input)
  }
`;

export const GET_ROLE_BY_ROLEID = gql`
  query Role($roleId: Int!) {
    role(roleId: $roleId) {
      roleId
      name
      orgId
      department
      prefix
      hierarcyOrder
      level
      deptId
      headOfOrg
    }
  }
`;
